(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["brunching-quick-add"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Full product name as a tooltip on the one line title */
    document.addEventListener('pointerover', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var heading = target.closest('.product-card .product-card__content :is(h1, h2, h3, h4, h5, h6)');
      if (heading && !heading.title) heading.title = heading.textContent.trim();
    });

    if (customElements.get('brunching-quick-add')) return;

    function root() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    class BrunchingQuickAdd extends HTMLElement {
      connectedCallback() {
        var variantsEl = this.querySelector('[data-bq-variants]');
        var sizesEl = this.querySelector('[data-bq-sizes]');
        this.variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
        this.sizes = sizesEl ? JSON.parse(sizesEl.textContent) : [];
        this.colourIndex = parseInt(this.dataset.colourIndex, 10);
        this.sizeIndex = parseInt(this.dataset.sizeIndex, 10);
        this.card = this.closest('.product-card, .bq-card');
        this.plus = this.querySelector('.bq__plus');
        this.row = this.querySelector('.bq__row');
        this.sizesWrap = this.querySelector('.bq__sizes');

        this.onPlus = this.onPlus.bind(this);
        this.onRow = this.onRow.bind(this);
        this.onDocument = this.onDocument.bind(this);
        this.refresh = this.refresh.bind(this);

        this.plus.addEventListener('click', this.onPlus);
        if (this.row) this.row.addEventListener('click', this.onRow);
        document.addEventListener('click', this.onDocument);
        if (this.card) this.card.addEventListener('change', this.refresh);

        this.refresh();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocument);
        if (this.card) this.card.removeEventListener('change', this.refresh);
      }

      selectedColour() {
        if (this.colourIndex < 0) return null;
        var input = this.card && this.card.querySelector('swatches-variant-picker-component input[type="radio"]:checked, input[data-bq-colour]:checked');
        if (input) return input.value;
        var first = this.variants.find(function (v) { return v.a; }) || this.variants[0];
        return first ? first.o[this.colourIndex] : null;
      }

      matchesColour(variant, colour) {
        return this.colourIndex < 0 || colour === null || variant.o[this.colourIndex] === colour;
      }

      directVariant() {
        var colour = this.selectedColour();
        var self = this;
        return this.variants.find(function (v) { return v.a && self.matchesColour(v, colour); });
      }

      refresh() {
        if (this.dataset.mode === 'direct') {
          this.plus.hidden = !this.directVariant();
          return;
        }

        var colour = this.selectedColour();
        var self = this;
        var anyAvailable = false;
        var html = '';

        this.sizes.forEach(function (size) {
          var variant = self.variants.find(function (v) {
            return self.matchesColour(v, colour) && v.o[self.sizeIndex] === size;
          });
          var label = String(size).replace(/[&<>"]/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
          });
          if (variant && variant.a) {
            anyAvailable = true;
            html += '<button type="button" class="bq__size" data-variant="' + variant.id + '">' + label + '</button>';
          } else {
            html += '<s class="bq__size--out" aria-label="' + label + ' sold out">' + label + '</s>';
          }
        });

        if (this.sizesWrap) this.sizesWrap.innerHTML = html;
        this.plus.hidden = !anyAvailable;
        if (!anyAvailable) this.close();
      }

      onPlus(event) {
        event.preventDefault();
        event.stopPropagation();

        if (this.dataset.mode === 'direct') {
          var variant = this.directVariant();
          if (variant) this.add(variant.id);
          return;
        }

        var self = this;
        document.querySelectorAll('brunching-quick-add.is-open').forEach(function (el) {
          if (el !== self && el.close) el.close();
        });
        this.refresh();
        this.classList.add('is-open');
      }

      onRow(event) {
        event.preventDefault();
        event.stopPropagation();
        var button = event.target.closest('[data-variant]');
        if (button) this.add(button.dataset.variant);
      }

      onDocument(event) {
        if (!this.contains(event.target)) this.close();
      }

      close() {
        this.classList.remove('is-open');
      }

      async add(variantId) {
        this.classList.add('is-busy');

        var sectionIds = [];
        document.querySelectorAll('cart-items-component').forEach(function (el) {
          if (el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
        });

        try {
          var response = await fetch(root() + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(variantId), quantity: 1 }],
              sections: sectionIds.join(','),
              sections_url: window.location.pathname
            })
          });
          var data = await response.json();
          if (!response.ok || data.status) throw data;

          var cart = await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
            return r.json();
          });

          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: 'brunching-quick-add',
                data: {
                  source: 'brunching-quick-add',
                  itemCount: cart.item_count,
                  variantId: String(variantId),
                  sections: data.sections || {}
                }
              }
            })
          );

          this.close();

          var drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          } else {
            window.location.href = root() + 'cart';
          }
        } catch (error) {
          console.error('Brunching quick add failed', error);
          window.location.href = root() + 'cart';
        } finally {
          this.classList.remove('is-busy');
        }
      }
    }

    customElements.define('brunching-quick-add', BrunchingQuickAdd);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["brunching-wishlist-header"] && !Shopify.designMode) return;
  try {
    (function () {
    function appButton() {
      return document.querySelector('.nm-wishlist-open-list-button');
    }

    function openWishlist(button) {
      button.style.setProperty('visibility', 'visible', 'important');
      button.click();
    }

    function updateCount() {
      var source = document.querySelector('.nm-wishlist-open-list-button .nm-wishlist-count-badge');
      var count = source ? parseInt(String(source.textContent).replace(/[^0-9]/g, ''), 10) : 0;
      if (isNaN(count)) count = 0;
      document.querySelectorAll('[data-brunch-wishlist-count]').forEach(function (bubble) {
        var text = count > 99 ? '99+' : String(count);
        if (count > 0) {
          if (bubble.textContent !== text) bubble.textContent = text;
          if (bubble.hidden) bubble.hidden = false;
        } else if (!bubble.hidden) {
          bubble.textContent = '';
          bubble.hidden = true;
        }
      });
    }

    document.addEventListener('click', function (event) {
      var heart = event.target.closest && event.target.closest('[data-brunch-wishlist]');
      if (!heart) return;
      event.preventDefault();
      var button = appButton();
      if (button) {
        openWishlist(button);
      } else {
        var tries = 0;
        var timer = setInterval(function () {
          tries += 1;
          var later = appButton();
          if (later) {
            clearInterval(timer);
            openWishlist(later);
          } else if (tries > 20) {
            clearInterval(timer);
          }
        }, 150);
      }
    });

    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        updateCount();
      });
    });

    function start() {
      updateCount();
      observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
